module.exports = "<div class=folder ng-class=vm.setFolderClass() ng-click=vm.toggleFolder()> {{vm.folderTitle}} <div ng-if=vm.showCount class=\"type-btn link inline-block type-regular\">{{vm.itemCount}} {{vm.itemLabel}}</div> </div> <div class=folder-content ng-class=\"{'is-open': vm.folderOpen}\" ng-if=vm.folderOpen ng-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./features/common/folder-collapse.html
// module id = 583
// module chunks = 0